<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Schedules Admin"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <List :center="user.center" class="mt-8" />
	</v-card>
</template>

<script>
import List from '@/components/schedules/List'

export default {
    components: {
        List
    }
}
</script>
